module.exports = __webpack_public_path__ + "img/user_hl_lx_selected.ad3207c2.png";